"use client";

import { useEffect } from "react";

import { installGoogleTranslateDomGuard } from "@/lib/google-translate-guard";

export default function GoogleTranslateGuard() {
  useEffect(() => {
    installGoogleTranslateDomGuard();
  }, []);

  return null;
}
